<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-form-model-item label="商品名称">
          <a-input v-model="formInline.name" placeholder="请输入" style="width: 200px">
            <a-icon
              slot="prefix"
              type="user"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="门店选择">
          <a-select
            v-model="formInline.shopId"
            placeholder="请选择门店"
            style="width: 250px"
            allowClear
          >
            <a-select-option
              v-for="item in storeList"
              :key="item.storeId"
              :value="item.storeId"
            >
              {{ item.storeName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" html-type="submit"> 条件查询 </a-button>
          <a-button type="primary"  style="margin-left: 10px" danger @click="resetForm"> 按skuId查询 </a-button>
          <a-button style="margin-left: 10px" @click="resetForm">
            重置
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <ticketPackageHomeContent
          ref="aaa"
          :formInline="formInline"
        ></ticketPackageHomeContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import ticketPackageHomeContent from "./ticketPackageHomeContent.vue";
import { getStoreList} from "@/api/homeApi.js";
export default {
  components: {
    ticketPackageHomeContent,
  },
  data() {
    return {
      formInline: {
        name: "",
        goodsType: 653,
        typeSonId: 655,
        limit: 10,
        page: 1,
        shopId:null,
      },
      storeList: [],
    };
    
  },
  mounted(){
    this.getstoresData();
  },
  methods: {
    
    handleSubmit(e) {
      console.log(this.formInline);
      this.$refs.aaa.query();
    },
    resetForm() {
      this.pagination={
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      this.$refs.aaa.getTokensListData();
       this.formInline= {
        name: "",
        goodsType: 653,
        typeSonId: 655,
        limit: 10,
        page: 1,
        shopId:null,
      };
      this.$refs.aaa.isStoreQueryPath = false;
      console.log(this.formInline);
      
    },
    getstoresData() {
      getStoreList().then((res) => {
        if(res.data){
          this.storeList = res.data;
        }
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/marketingManagement/AdminTicketPackage/ticketPackageHome.vue